import { render, staticRenderFns } from "./pwdLogin.vue?vue&type=template&id=16a9b0ec&scoped=true"
import script from "./pwdLogin.vue?vue&type=script&lang=js"
export * from "./pwdLogin.vue?vue&type=script&lang=js"
import style0 from "./pwdLogin.vue?vue&type=style&index=0&id=16a9b0ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a9b0ec",
  null
  
)

export default component.exports